module.exports = __webpack_public_path__ + "static/media/CS_JAN24_-100.21bb20ee.jpg";